(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2833],{

/***/ 12472:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 12472;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 56817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zv": function() { return /* binding */ defaultLimitOrderUrl; },
/* harmony export */   "be": function() { return /* binding */ fromOrderSequenceNumberToOrderSide; },
/* harmony export */   "wA": function() { return /* binding */ sortBySellingSide; }
/* harmony export */ });
/* unused harmony export MAX_ORDERS */
/* harmony import */ var _trathailoi_phoenix_orderbook_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86439);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1880);


const defaultLimitOrderUrl = "/limit/".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__/* .isMainnet */ .mC ? "reBTC_reUSD" : "reVND_reUSD");
const MAX_ORDERS = 20;
const fromOrderSequenceNumberToOrderSide = (orderSequenceNumber)=>{
    const twosComplement = (0,_trathailoi_phoenix_orderbook_sdk__WEBPACK_IMPORTED_MODULE_0__/* .toBN */ .Mdv)(orderSequenceNumber).fromTwos(64);
    return twosComplement.isNeg() ? _trathailoi_phoenix_orderbook_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Side.Bid */ .MFA.Bid : _trathailoi_phoenix_orderbook_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Side.Ask */ .MFA.Ask;
};
const sortBySellingSide = (side)=>side === _trathailoi_phoenix_orderbook_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Side.Ask */ .MFA.Ask ? 1 : -1;


/***/ }),

/***/ 53844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_subscribed_telegram; }
});

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/utils/apis/index.ts
var apis = __webpack_require__(40795);
;// CONCATENATED MODULE: ./src/utils/apis/telegram-subscribers.ts

const checkSubscribedTelegram = async (walletAddress)=>{
    const { data  } = await apis/* api.get */.h.get("telegram_subscribers/subscribed", {
        params: {
            wallet_address: walletAddress
        }
    });
    return data;
};

// EXTERNAL MODULE: ./src/wallet/adapter.ts + 1 modules
var adapter = __webpack_require__(33618);
;// CONCATENATED MODULE: ./src/hooks/use-subscribed-telegram.ts



const useSubscribedTelegram = ()=>{
    const { publicKey  } = (0,adapter/* useWallet */.Os)();
    return (0,es.useQuery)([
        "subscribedTelegram",
        publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58()
    ], ()=>{
        return checkSubscribedTelegram(publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58());
    }, {
        refetchOnWindowFocus: false,
        enabled: !!publicKey
    });
};
/* harmony default export */ var use_subscribed_telegram = (useSubscribedTelegram);


/***/ }),

/***/ 33509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/src/effects/blur.css
var effects_blur = __webpack_require__(86946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 1 modules
var useTrans = __webpack_require__(39838);
;// CONCATENATED MODULE: ./src/components/base/seo.tsx





const Seo = (param)=>{
    let { data  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const defaultData = trans.meta[(0,constants/* isInstantWireMode */.Zo)() ? "instantwire" : "home"];
    const { title , description , url , thumbnailUrl , keywords  } = {
        ...defaultData,
        ...data
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            keywords ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: keywords
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: thumbnailUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:image",
                content: thumbnailUrl
            })
        ]
    });
};
/* harmony default export */ var seo = (Seo);

;// CONCATENATED MODULE: ./src/components/base/index.ts


// EXTERNAL MODULE: ./src/utils/use-is-mobile.ts
var use_is_mobile = __webpack_require__(11679);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/static-import-icon.tsx + 42 modules
var static_import_icon = __webpack_require__(61930);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/footer/helpers.ts


const getSocialNetworkList = ()=>{
    return (0,constants/* isInstantWireMode */.Zo)() ? [
        {
            iconAlt: "facebook",
            iconBg: "#1F5F8D",
            iconSrc: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.FACEBOOK_WHITE */.u.FACEBOOK_WHITE),
            name: "Facebook",
            url: "https://www.facebook.com/instantwire"
        },
        {
            iconAlt: "twitter",
            iconBg: "#1F5F8D",
            iconSrc: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.TWITTER_WHITE */.u.TWITTER_WHITE),
            name: "Twitter",
            url: "https://twitter.com/InstantWireInfo"
        },
        {
            iconAlt: "facebook",
            iconBg: "#1F5F8D",
            iconSrc: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.TELEGRAM_WHITE */.u.TELEGRAM_WHITE),
            name: "Telegram",
            url: "https://t.me/InstantwireCommunity"
        }
    ] : [
        {
            iconAlt: "discord",
            iconBg: "#21D969",
            iconSrc: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.DISCORD_BLACK */.u.DISCORD_BLACK),
            name: "Telegram",
            url: "https://discord.gg/JNvaFP5QCz"
        },
        {
            iconAlt: "reddit",
            iconBg: "#21D969",
            iconSrc: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.REDDIT_BLACK */.u.REDDIT_BLACK),
            name: "Reddit",
            url: "https://www.reddit.com/r/renecblockchain/"
        },
        {
            iconAlt: "twitter",
            iconBg: "#21D969",
            iconSrc: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.TWITTER_BLACK */.u.TWITTER_BLACK),
            name: "Twitter",
            url: "https://twitter.com/NemoSwapDEX"
        },
        {
            iconAlt: "telegram",
            iconBg: "#21D969",
            iconSrc: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.TELEGRAM_BLACK */.u.TELEGRAM_BLACK),
            name: "Telegram",
            url: "https://t.me/NemoSwapGroup"
        }
    ];
};

;// CONCATENATED MODULE: ./src/layouts/MainLayout/footer/footer.desktop.tsx







const FooterDesktop = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: "w-full bg-black/40 iw:bg-white py-4 relative z-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                className: "w-full flex-col sm:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: {
                            sm: "column",
                            md: "row"
                        },
                        justifyContent: "center",
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                "data-testid": "footer-copyright",
                                variant: "body2",
                                color: "textSecondary",
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " ",
                                    (0,constants/* isInstantWireMode */.Zo)() ? "Instantwire" : "Renec Foundation",
                                    ". All rights reserved."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "/terms-and-conditions",
                                variant: "body2",
                                color: "textSecondary",
                                children: trans.terms_of_use
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        "data-testid": "social-links-wrapper",
                        direction: "row",
                        justifyContent: "end",
                        alignItems: "center",
                        spacing: 2,
                        className: "mt-3 sm:mt-0",
                        children: getSocialNetworkList().map((value, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                title: value.name,
                                placement: "top",
                                TransitionComponent: Fade/* default */.Z,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    "data-testid": "social-link-".concat(value.iconAlt),
                                    href: value.url,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-6 h-6 p-1.5 rounded-full",
                                        style: {
                                            background: value.iconBg
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: value.iconSrc,
                                            alt: value.iconAlt,
                                            width: 12
                                        })
                                    })
                                })
                            }, index))
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var footer_desktop = (/*#__PURE__*/(0,react.memo)(FooterDesktop));

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/MoreHoriz.js
var MoreHoriz = __webpack_require__(79369);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(17417);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/navigation.js
var navigation = __webpack_require__(39332);
// EXTERNAL MODULE: ./src/contexts/pending-transactions/index.tsx + 4 modules
var pending_transactions = __webpack_require__(25711);
// EXTERNAL MODULE: ./node_modules/lodash/partition.js
var partition = __webpack_require__(43174);
var partition_default = /*#__PURE__*/__webpack_require__.n(partition);
// EXTERNAL MODULE: ./src/components/limit-order/helpers.ts
var helpers = __webpack_require__(56817);
;// CONCATENATED MODULE: ./src/hooks/use-header-nav/pending-transactions-badge.tsx

const PendingTransactionsBadge = (param)=>{
    let { isDisplayPendingBadge , pendingTransactionCount  } = param;
    return isDisplayPendingBadge ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "ml-[3px] inline-block h-4 min-w-[16px] bg-[#FF6701] rounded-full font-bold text-center text-xs pointer-events-none px-[3px]",
        children: pendingTransactionCount
    }) : null;
};
/* harmony default export */ var pending_transactions_badge = (PendingTransactionsBadge);

// EXTERNAL MODULE: ./src/hooks/use-settings.ts + 1 modules
var use_settings = __webpack_require__(49472);
;// CONCATENATED MODULE: ./src/hooks/use-header-nav/index.tsx









const useHeaderItems = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    const { data: settingsData , isLoading: isLoadingSettings  } = (0,use_settings/* useSettings */.r)();
    const { isDisplayPendingBadge , pendingTxCountByTrades  } = (0,react.useContext)(pending_transactions/* PendingTransactionsCtx */.F);
    const menus = (0,react.useMemo)(()=>{
        const isInstantWire = (0,constants/* isInstantWireMode */.Zo)();
        const isNemo = !isInstantWire;
        return [
            {
                name: "trade",
                label: trans.header.trade,
                activeHref: "/swap",
                href: "/swap",
                enabled: isNemo,
                badge: null,
                dataTestId: "header-trade"
            },
            {
                name: "p2p-market",
                label: trans.header.p2p_market,
                activeHref: [
                    "/",
                    "/p2p"
                ],
                href: "/p2p",
                enabled: !isLoadingSettings && (settingsData === null || settingsData === void 0 ? void 0 : settingsData.p2p_market_feature_enabled),
                badge: null,
                dataTestId: "header-nav-p2p-market"
            },
            {
                name: "assets",
                label: trans.header.assets,
                activeHref: "/assets",
                href: "/assets",
                enabled: isNemo,
                badge: null,
                dataTestId: "header-menu-assets"
            },
            {
                name: "limit",
                label: trans.header.limit,
                activeHref: "/limit",
                href: helpers/* defaultLimitOrderUrl */.Zv,
                enabled: isNemo && !isLoadingSettings && (settingsData === null || settingsData === void 0 ? void 0 : settingsData.orderbook_feature_enabled),
                badge: null,
                dataTestId: "header-nav-limit"
            },
            {
                name: "liquidity",
                label: trans.header.liquidity,
                activeHref: "/liquidity",
                href: "/liquidity/browse",
                enabled: isNemo,
                badge: null,
                dataTestId: "header-menu-liquidity"
            },
            {
                name: "history",
                label: trans.header.transactions,
                activeHref: "/history",
                href: "/history",
                enabled: true,
                badge: /*#__PURE__*/ (0,jsx_runtime.jsx)(pending_transactions_badge, {
                    isDisplayPendingBadge: isDisplayPendingBadge,
                    pendingTransactionCount: pendingTxCountByTrades
                }),
                dataTestId: "header-menu-history"
            }
        ];
    }, [
        trans,
        settingsData,
        isDisplayPendingBadge,
        pendingTxCountByTrades,
        isLoadingSettings
    ]);
    const [shownItems, moreItems] = (0,react.useMemo)(()=>{
        const enabledMenus = menus.filter((item)=>item.enabled);
        return partition_default()(enabledMenus, (item)=>enabledMenus.indexOf(item) < 3);
    }, [
        menus
    ]);
    return {
        menus,
        shownItems,
        moreItems
    };
};

// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 3 modules
var MenuItem = __webpack_require__(23599);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/use-amplitude.ts + 61 modules
var use_amplitude = __webpack_require__(54341);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var utils_helpers = __webpack_require__(73680);
;// CONCATENATED MODULE: ./src/layouts/components/MenuLink.tsx









const MenuLink = (param)=>{
    let { activeHref , ...props } = param;
    const amplitude = (0,use_amplitude/* default */.Z)();
    const pathname = (0,navigation.usePathname)();
    const isMobile = (0,use_is_mobile/* useIsMobile */.d)();
    const selectedActiveHref = activeHref || props.href;
    const isActive = (0,react.useMemo)(()=>{
        const currentPath = pathname || "";
        const activePaths = selectedActiveHref instanceof Array ? selectedActiveHref : [
            selectedActiveHref || ""
        ];
        return (0,utils_helpers/* isActiveMenuLink */.N$)(currentPath, activePaths);
    }, [
        pathname,
        selectedActiveHref
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        color: "secondary",
        component: (link_default()),
        onClick: ()=>{
            var _props_href;
            amplitude.track(use_amplitude/* EVENT_NAMES.page_select_header_menu */.K.page_select_header_menu, {
                // remove first slash and replace other slashes as dashes
                menu_name: ((_props_href = props.href) === null || _props_href === void 0 ? void 0 : _props_href.replace(/^\//, "").replace(/\//g, "-")) || "home"
            });
        },
        ...props,
        className: classnames_default()("menu-link text-sm no-underline sm:text-base whitespace-nowrap hover:opacity-80 px-4 py-2", props.className, {
            "text-[#C2CBD9] iw:text-[#666666]": !isActive,
            "font-bold iw:text-[#1F5F8D] menu-link--active": isActive,
            "text-[#FF6701]": isActive && !isMobile,
            "rounded-[100px] bg-[#1E2735] iw:bg-white": isActive && isMobile
        })
    });
};
/* harmony default export */ var components_MenuLink = (MenuLink);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/ExtendedMenuItems.tsx





const ExtendedMenuItems = (param)=>{
    let { handleClose  } = param;
    const { moreItems  } = useHeaderItems();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: moreItems.map((menu)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                onClick: handleClose,
                disableRipple: true,
                className: "p-0 items-stretch justify-items-stretch",
                "data-testid": menu.dataTestId,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MenuLink, {
                    className: "flex items-center py-[6px] px-[16px] w-full",
                    activeHref: menu.activeHref,
                    href: menu.href,
                    "data-testid": "header-nav-".concat(menu.name),
                    children: [
                        menu.label,
                        menu.badge
                    ]
                })
            }, menu.name))
    });
};
/* harmony default export */ var components_ExtendedMenuItems = (/*#__PURE__*/(0,react.memo)(ExtendedMenuItems));

;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/MainMenuItems.tsx





const MainMenuItems = ()=>{
    const { shownItems  } = useHeaderItems();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shownItems.map((menu)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuLink, {
                    href: menu.href,
                    "data-testid": menu.dataTestId,
                    activeHref: menu.activeHref,
                    children: menu.label
                })
            }, menu.name))
    });
};
/* harmony default export */ var components_MainMenuItems = (MainMenuItems);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/footer/footer.mobile.tsx
























const FooterMobile = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    const [anchorEl, setAnchorEl] = (0,react.useState)(null);
    const ref = (0,react.useRef)();
    const open = Boolean(anchorEl);
    const { moreItems  } = useHeaderItems();
    const { isDisplayPendingBadge , pendingTxCountByTrades  } = (0,react.useContext)(pending_transactions/* PendingTransactionsCtx */.F);
    const pathname = (0,navigation.usePathname)();
    const isActive = (0,react.useMemo)(()=>{
        return (0,utils_helpers/* isActiveMenuLink */.N$)(pathname || "", utils_helpers/* LINK_EXPANDED_MENU_ITEMS */.tx);
    }, [
        pathname
    ]);
    const handleClick = ()=>{
        setAnchorEl(anchorEl ? null : ref.current);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: "w-full fixed z-10 bottom-[8px]",
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                onClickAway: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "bg-[#121823] rounded-[28px] p-2 iw:bg-[#DFF1FF]",
                    style: {
                        boxShadow: (0,constants/* isInstantWireMode */.Zo)() ? "0px 2px 4px 0px #0000001A" : ""
                    },
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainMenuItems, {}),
                        moreItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: "relative",
                                children: [
                                    isDisplayPendingBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-testid": "pending-tx-count-mobile",
                                        className: "absolute h-4 min-w-[16px] bg-[#FF6701] rounded-full font-bold text-center text-xs pointer-events-none px-[3px] top-[-8px] left-[50%] translate-x-[-50%] text-white",
                                        children: pendingTxCountByTrades
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreHoriz/* default */.Z, {
                                        "data-testid": "btn-extra-menu",
                                        onClick: handleClick,
                                        className: classnames_default()("sm:block cursor-pointer opacity-80 hover:opacity-100", open && "opacity-100", isActive && "rounded-[100px] bg-[#1E2735] iw:bg-white")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                            open: open,
                            anchorEl: ref.current,
                            placement: "top",
                            className: "z-10 w-full px-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: "bg-[#1E2735] iw:bg-white rounded-[16px] border border-[#61667E] p-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExtendedMenuItems, {
                                        handleClose: handleClose
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        "data-testid": "social-links-wrapper",
                                        direction: "row",
                                        justifyContent: "start",
                                        alignItems: "center",
                                        spacing: 3,
                                        className: "px-4 py-4",
                                        children: getSocialNetworkList().map((value, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                title: value.name,
                                                placement: "top",
                                                TransitionComponent: Fade/* default */.Z,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    "data-testid": "social-link-".concat(value.iconAlt),
                                                    href: value.url,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-6 h-6 p-1 rounded-full",
                                                        style: {
                                                            background: value.iconBg
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: value.iconSrc,
                                                            alt: value.iconAlt,
                                                            width: 16
                                                        })
                                                    })
                                                })
                                            }, index))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        className: "px-2 py-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        spacing: 2,
                                        className: "py-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                "data-testid": "footer-copyright",
                                                variant: "body2",
                                                color: "textSecondary",
                                                textAlign: "center",
                                                children: [
                                                    "\xa9 ",
                                                    new Date().getFullYear(),
                                                    " ",
                                                    (0,constants/* isInstantWireMode */.Zo)() ? "Instantwire" : "Renec Foundation",
                                                    ". All rights reserved."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: "/terms-and-conditions",
                                                variant: "body2",
                                                color: "textSecondary",
                                                children: trans.terms_of_use
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var footer_mobile = (FooterMobile);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/footer/index.tsx




const Footer = ()=>{
    const isMobile = (0,use_is_mobile/* useIsMobile */.d)();
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_mobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_desktop, {});
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./node_modules/react-stickynode/dist/es/Sticky.js + 11 modules
var Sticky = __webpack_require__(3238);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/constants/amplitude.ts
var constants_amplitude = __webpack_require__(78017);
// EXTERNAL MODULE: ./src/wallet/adapter.ts + 1 modules
var adapter = __webpack_require__(33618);
// EXTERNAL MODULE: ./src/providers/wallet-balances/index.tsx
var wallet_balances = __webpack_require__(1706);
;// CONCATENATED MODULE: ./src/wallet/ui/WalletBalances.tsx




const WalletBalances = ()=>{
    const { userBalances  } = (0,react.useContext)(wallet_balances/* WalletBalancesContext */.S);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        display: "none",
        children: Object.keys(userBalances).map((tokenSymbol)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                "data-testid": "wallet-has-".concat(tokenSymbol),
                "data-amount": userBalances[tokenSymbol]
            }, tokenSymbol);
        })
    });
};
/* harmony default export */ var ui_WalletBalances = (WalletBalances);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/ConnectWallet/index.tsx







const WalletMultiButtonDynamic = dynamic_default()(()=>__webpack_require__.e(/* import() */ 622).then(__webpack_require__.bind(__webpack_require__, 50622)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50622)
            ]
    },
    ssr: false
});
const ConnectWallet = ()=>{
    const amplitude = (0,use_amplitude/* default */.Z)();
    const { publicKey  } = (0,adapter/* useWallet */.Os)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        onClick: ()=>{
            if (!publicKey) {
                amplitude.track(constants_amplitude/* EVENT_NAMES.page_connect_wallet_on_header */.K.page_connect_wallet_on_header);
            }
        },
        "data-connected": !!publicKey,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletMultiButtonDynamic, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_WalletBalances, {})
        ]
    });
};
/* harmony default export */ var components_ConnectWallet = (ConnectWallet);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/QrCodeScanner.js
var QrCodeScanner = __webpack_require__(78394);
;// CONCATENATED MODULE: ./src/assets/svgs/download-wallet-app-qrcode.svg
/* harmony default export */ var download_wallet_app_qrcode = ({"src":"/_next/static/media/download-wallet-app-qrcode.b3360183.svg","height":1007,"width":1007});
;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/DownloadWalletAppQrIcon/index.tsx








const DownloadWalletAppQrIcon = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    if ((0,constants/* isInstantWireMode */.Zo)()) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        placement: "bottom-end",
        componentsProps: {
            tooltip: {
                className: "bg-semiblack-300 mt-5 py-6 px-4 rounded-lg"
            }
        },
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            alignItems: "center",
            className: "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: download_wallet_app_qrcode,
                    "data-testid": "qr-install-carax",
                    alt: "qr-install-carax",
                    width: 170,
                    height: 170
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: "text-gray-100 text-xs pt-3",
                    children: trans.scan_to_download_wallet_app
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QrCodeScanner/* default */.Z, {
            "data-testid": "show-qr-install-carax-icon",
            className: "w-6 h-6 hover:text-white text-semiblack-600 mr-1"
        })
    });
};
/* harmony default export */ var components_DownloadWalletAppQrIcon = (DownloadWalletAppQrIcon);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var Menu = __webpack_require__(326);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 5 modules
var Menu_Menu = __webpack_require__(93419);
;// CONCATENATED MODULE: ./src/layouts/components/ExtraMenuItems.tsx












const ExtraMenuItems = ()=>{
    const anchorEl = (0,react.useRef)(null);
    const { moreItems  } = useHeaderItems();
    const { isDisplayPendingBadge , pendingTxCountByTrades  } = (0,react.useContext)(pending_transactions/* PendingTransactionsCtx */.F);
    const [isOpenMoreMenu, setIsOpenMoreMenu] = (0,react.useState)(false);
    const pathname = (0,navigation.usePathname)();
    const isActive = (0,react.useMemo)(()=>{
        return (0,utils_helpers/* isActiveMenuLink */.N$)(pathname || "", utils_helpers/* LINK_EXPANDED_MENU_ITEMS */.tx);
    }, [
        pathname
    ]);
    const handleClick = (0,react.useCallback)(()=>{
        setIsOpenMoreMenu(true);
    }, []);
    const handleClose = (0,react.useCallback)(()=>{
        setIsOpenMoreMenu(false);
    }, []);
    if (!moreItems.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                ref: anchorEl,
                id: "menu-more-options",
                onClick: handleClick,
                "data-testid": "btn-extra-menu",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: "relative",
                        children: [
                            isDisplayPendingBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute h-4 min-w-[16px] bg-[#FF6701] rounded-full font-bold text-center text-xs pointer-events-none px-[3px] top-[-8px] left-[50%] translate-x-[-50%]",
                                children: pendingTxCountByTrades
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreHoriz/* default */.Z, {
                                className: classnames_default()("hidden sm:block cursor-pointer opacity-80 hover:opacity-100", isOpenMoreMenu && "opacity-100", isActive && "text-[#FF6701]")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                        className: classnames_default()("block sm:hidden cursor-pointer opacity-80 hover:opacity-100", isOpenMoreMenu && "opacity-100", isActive && "text-[#FF6701]")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                id: "menu-items-more-options",
                anchorEl: anchorEl.current,
                open: isOpenMoreMenu,
                onClose: handleClose,
                anchorOrigin: {
                    horizontal: "right",
                    vertical: "bottom"
                },
                transformOrigin: {
                    horizontal: "right",
                    vertical: "top"
                },
                MenuListProps: {
                    "aria-labelledby": "menu-more-options"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExtendedMenuItems, {
                    handleClose: handleClose
                })
            })
        ]
    });
};
/* harmony default export */ var components_ExtraMenuItems = (/*#__PURE__*/(0,react.memo)(ExtraMenuItems));

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/base/icons/ArrowUpRight.tsx

const ArrowUpRight = (param)=>{
    let { width =24 , height =24 , fill ="currentColor"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Icon",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Vector 431 (Stroke)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.375 3.125L16.75 3.125C16.9158 3.125 17.0747 3.19085 17.1919 3.30806C17.3092 3.42527 17.375 3.58424 17.375 3.75V13.125C17.375 13.4702 17.0952 13.75 16.75 13.75C16.4048 13.75 16.125 13.4702 16.125 13.125V5.25888L4.69194 16.6919C4.44786 16.936 4.05214 16.936 3.80806 16.6919C3.56398 16.4479 3.56398 16.0521 3.80806 15.8081L15.2411 4.375L7.375 4.375C7.02982 4.375 6.75 4.09518 6.75 3.75C6.75 3.40482 7.02982 3.125 7.375 3.125Z",
                fill: fill
            })
        })
    });
};
/* harmony default export */ var icons_ArrowUpRight = (ArrowUpRight);

// EXTERNAL MODULE: ./src/hooks/use-feature-flag.ts
var use_feature_flag = __webpack_require__(67153);
// EXTERNAL MODULE: ./src/hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(72411);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/LeaderBoardHeader.tsx












const LeaderBoardHeader = ()=>{
    const router = (0,next_router.useRouter)();
    const amplitude = (0,use_amplitude/* default */.Z)();
    const trans = (0,useTrans/* default */.Z)();
    const theme = (0,useTheme/* default */.Z)();
    const isDesktop = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const [isBannerClosedByUser, setIsBannerClosedByUser] = (0,useLocalStorage/* default */.Z)("p2p_leader_board_banner_hidden", false);
    const { enabled: isFeatureEnabled  } = (0,use_feature_flag/* default */.Z)("leader_board_feature_enabled");
    const isAlreadyOnLeaderBoardPage = router.pathname.includes("leader-board");
    const showHeader = (0,constants/* isInstantWireMode */.Zo)() && isFeatureEnabled && !isAlreadyOnLeaderBoardPage && !isBannerClosedByUser;
    const handleClick = (0,react.useCallback)(()=>{
        amplitude.track(use_amplitude/* EVENT_NAMES.leader_board_top_banner */.K.leader_board_top_banner);
        router.push("/p2p/leader-board");
    }, [
        router,
        amplitude
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
        in: showHeader,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            "data-testid": "leader-board-header",
            direction: "row",
            className: "iw:bg-[#1F5F8D] p-2 w-full bg-transparent",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    flexGrow: 1,
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        "data-testid": "leader-board-header-btn",
                        direction: "row",
                        className: "flex-grow cursor-pointer text-white hover:underline",
                        justifyContent: "center",
                        alignItems: "center",
                        onClick: handleClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "sale-icon",
                                src: "/lightning-speaker.png",
                                height: 26,
                                width: 32
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-xs ml-3",
                                children: trans.p2p_leader_board_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: "ml-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ArrowUpRight, {
                                    height: isDesktop ? 20 : 16,
                                    width: isDesktop ? 20 : 16,
                                    fill: (0,constants/* isInstantWireMode */.Zo)() ? "#F79009" : "#FF6701"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                    "data-testid": "leader-board-header-close-btn",
                    className: "text-white cursor-pointer opacity-80 hover:opacity-100 ml-auto",
                    fontSize: "small",
                    onClick: ()=>setIsBannerClosedByUser(true)
                })
            ]
        })
    });
};
/* harmony default export */ var components_LeaderBoardHeader = (LeaderBoardHeader);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Notifications.js
var Notifications = __webpack_require__(65817);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Telegram.js
var Telegram = __webpack_require__(25128);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./src/hooks/use-subscribed-telegram.ts + 1 modules
var use_subscribed_telegram = __webpack_require__(53844);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/SubscribeTelegramIcon/index.tsx








const SubscribeTelegramIcon = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    const { publicKey  } = (0,adapter/* useWallet */.Os)();
    const { data: subscribed , isLoading  } = (0,use_subscribed_telegram/* default */.Z)();
    if (!publicKey || isLoading || subscribed) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        leaveDelay: 500,
        enterTouchDelay: 0,
        placement: "bottom-end",
        componentsProps: {
            tooltip: {
                className: "bg-semiblack-300 mt-5 py-6 px-4 rounded-lg"
            }
        },
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            alignItems: "center",
            className: "w-min text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: "text-gray-100 text-xs pb-3",
                    children: trans.telegram_subscribe.message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    className: "bg-[#23B7EC] rounded-lg normal-case py-2.5 px-9",
                    "data-testid": "subscribe-telegram-button",
                    href: "https://t.me/nemoswap_bot?start=".concat(publicKey),
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Telegram/* default */.Z, {
                            className: "mr-2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: "text-sm whitespace-nowrap",
                            children: trans.telegram_subscribe.subscribe
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Notifications/* default */.Z, {
                    "data-testid": "subscribe-telegram-icon",
                    className: "w-8 h-8 hover:text-white iw:hover:text-[#000E0F] text-semiblack-600"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: "rounded w-2 h-2 bg-[#EB5757] absolute top-1.5 right-1"
                })
            ]
        })
    });
};
/* harmony default export */ var components_SubscribeTelegramIcon = (SubscribeTelegramIcon);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/header/header.desktop.tsx













const HeaderDesktop = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticky/* default */.Z, {
        className: "z-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            className: "bg-header",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LeaderBoardHeader, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        className: "flex-wrap w-full h-full py-[5px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                className: "justify-between w-full sm:w-fit sm:justify-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "start",
                                        alignItems: "center",
                                        className: "mr-4 sm:mr-12",
                                        flexShrink: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuLink, {
                                            href: "/",
                                            "data-testid": "header-home-trade",
                                            className: "!px-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: ((0,constants/* isInstantWireMode */.Zo)() ? "/instantwire" : "") + "/logo.svg",
                                                alt: (0,constants/* isInstantWireMode */.Zo)() ? "InstantWire" : "NemoSwap",
                                                width: "176",
                                                height: "32",
                                                className: "min-w-min"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "start",
                                        alignItems: "center",
                                        spacing: {
                                            sm: 5,
                                            xs: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainMenuItems, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                className: "py-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExtraMenuItems, {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                spacing: 2,
                                className: "w-full mt-2 sm:w-fit sm:mt-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConnectWallet, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DownloadWalletAppQrIcon, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SubscribeTelegramIcon, {})
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var header_desktop = (/*#__PURE__*/(0,react.memo)(HeaderDesktop));

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SmsOutlined.js
var SmsOutlined = __webpack_require__(66418);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@thanhvo102/react-use-intercom/dist/react-use-intercom.esm.js
var react_use_intercom_esm = __webpack_require__(91567);
// EXTERNAL MODULE: ./node_modules/@mui/material/useScrollTrigger/useScrollTrigger.js
var useScrollTrigger = __webpack_require__(8298);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(54776);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/components/HideOnScroll.tsx


const HideOnScroll = (param)=>{
    let { children  } = param;
    const trigger = (0,useScrollTrigger/* default */.Z)({
        disableHysteresis: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
        appear: false,
        direction: "down",
        in: !trigger,
        children: children
    });
};
/* harmony default export */ var components_HideOnScroll = (HideOnScroll);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/header/header.mobile.tsx













const HeaderMobile = ()=>{
    const { show  } = (0,react_use_intercom_esm/* useIntercom */.o)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticky/* default */.Z, {
        className: "z-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LeaderBoardHeader, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HideOnScroll, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: "flex items-center bg-header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            className: "flex-wrap w-full h-full py-[5px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "start",
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuLink, {
                                        href: "/",
                                        activeHref: "none",
                                        "data-testid": "header-home-trade",
                                        className: "!px-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: ((0,constants/* isInstantWireMode */.Zo)() ? "/instantwire" : "") + "/logo-mobile.svg",
                                            alt: (0,constants/* isInstantWireMode */.Zo)() ? "InstantWire" : "NemoSwap",
                                            width: "32",
                                            height: "32",
                                            className: "min-w-min"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConnectWallet, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            onClick: show,
                                            "data-testid": "mobile-intercom-launcher",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmsOutlined/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SubscribeTelegramIcon, {})
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var header_mobile = (/*#__PURE__*/(0,react.memo)(HeaderMobile));

;// CONCATENATED MODULE: ./src/layouts/MainLayout/header/index.tsx




const Header = ()=>{
    const isMobile = (0,use_is_mobile/* useIsMobile */.d)();
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(header_mobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(header_desktop, {});
};
/* harmony default export */ var header = (Header);

// EXTERNAL MODULE: ./node_modules/react-just-parallax/dist/esm/index.js
var esm = __webpack_require__(34350);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/NormalBackground.tsx




const NormalBackground = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MouseParallax */.S, {
            isAbsolutelyPositioned: true,
            strength: 0.01,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: "fixed -left-[120px] sm:-left-[130px] top-[40vh] sm:top-[170px] w-[400px] sm:w-[664px]",
                "data-testid": "coin-bubble-left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                    src: "/ship.webp",
                    placeholderSrc: "/ship_placeholder.webp",
                    alt: "ship",
                    effect: "blur",
                    width: "100%",
                    height: "100%"
                })
            })
        })
    });
};
/* harmony default export */ var MainLayout_NormalBackground = (NormalBackground);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/index.tsx







const MainLayout = (param)=>{
    let { hasNautilus , hasContainer =true , children , slot  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "relative w-full min-h-screen overflow-hidden sm:h-screen bg-gradient-primary",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 bg-forest-bottom"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
                    slot,
                    hasNautilus && /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout_NormalBackground, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        className: "pb-[100px] max-[767px]:pb-[80px] md:pb-0 z-10 flex-1 overflow-auto",
                        children: hasContainer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: children
                        }) : children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
                ]
            })
        ]
    });
};


/***/ })

}]);